import {ProductPriceList} from './product-price-list';
import {BrandID} from "../enums/brand-id";

export class Product {

  productGuid!: string;
  active!: boolean;
  beginEffectiveDate!: Date;
  classCode!: string;
  commodityCode!: string;
  createTimestamp!: Date;
  createUser!: string;
  description!: string;
  descriptionShort!: string;
  diameter!: number;
  endEffectiveDate!: Date;
  configuration!: boolean;
  kit!: boolean;
  itemNumber!: string;
  externalNotes!: string;
  productCategory!: string;
  plnIdDescription!: string;
  whereUsed!: string;
  unitSize!: number;
  leadTimeID!: number;
  orderable!: boolean;
  productId!: string;
  riserInsulationThickness!: string;
  riserType!: string;
  productUomCode!: string;
  shippableItem!: boolean;
  spares!: boolean;
  typeCode!: string;
  updateTimestamp!: Date;
  updateUser!: string;
  priceLists!: ProductPriceList[];
  modular!: boolean;
  vendorSupplied!: boolean;
  brandID!: BrandID;

}
